import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { getPostPaymentRedirect, clearPostPaymentRedirect } from '../../utils/loginRedirect';

export default function PaymentCancel() {
  const navigate = useNavigate();

  // Checkout started from a page that wants the user back (e.g. a shared
  // report's Unlock) — offer that instead of the plans page.
  const [returnPath] = useState(() => getPostPaymentRedirect());
  useEffect(() => {
    clearPostPaymentRedirect();
  }, []);

  const handleTryAgain = () => {
    navigate(returnPath || '/profile'); // Go back to where checkout started, or the plans page
  };

  const handleGoHome = () => {
    navigate('/'); // Go to home page
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
          <Col md={8} lg={6}>
            <Card 
              className="shadow"
              style={{
                background: '#21222D',
                border: '1px solid #353748',
                borderRadius: '8px'
              }}
            >
              <CardBody className="text-center p-5">
                {/* Cancel Icon */}
                <div className="mb-4">
                  <div 
                    className="rounded-circle d-inline-flex align-items-center justify-content-center" 
                    style={{ 
                      width: '80px', 
                      height: '80px',
                      background: 'linear-gradient(135deg, #F6255A, grey)'
                    }}
                  >
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                            stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>

                {/* Cancel Message */}
                <h2 className="mb-3" style={{ fontFamily: 'Rubik', fontWeight: 600, color: '#FFFFFF' }}>
                  Payment Cancelled
                </h2>
                <p className="mb-4" style={{ color: '#FFFFFF' }}>
                  Your payment was cancelled. No charges have been made to your account.
                </p>

                {/* Additional Info */}
                <div 
                  className="rounded p-4 mb-4"
                  style={{
                    background: '#171821',
                    border: '1px solid #353748'
                  }}
                >
                  <h6 className="mb-3" style={{ fontFamily: 'Rubik', fontWeight: 600, color: '#fff' }}>
                    What happened?
                  </h6>
                  <ul className="text-start mb-0" style={{ color: '#A1ACB8' }}>
                    <li>You cancelled the payment process</li>
                    <li>No charges were made to your account</li>
                    <li>Your current plan remains unchanged</li>
                    <li>You can try again anytime</li>
                  </ul>
                </div>

                {/* Action Buttons */}
                <div className="d-grid gap-3">
                  <Button 
                    color="primary" 
                    size="lg" 
                    onClick={handleTryAgain}
                    style={{
                      background: '#F6255A',
                      border: 'none',
                      borderRadius: '20px',
                      padding: '12px 24px',
                      fontFamily: 'Rubik',
                      fontWeight: 600,
                      fontSize: '16px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#e11d4c';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '#F6255A';
                    }}
                  >
                    {returnPath ? 'Back to Report' : 'Try Again'}
                  </Button>
                  <Button 
                    color="outline-secondary" 
                    onClick={handleGoHome}
                    style={{
                      background: '#171821',
                      border: '1px solid #353748',
                      color: '#A1ACB8',
                      borderRadius: '20px',
                      padding: '12px 24px',
                      fontFamily: 'Rubik',
                      fontWeight: 500,
                      fontSize: '16px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#2A2C38';
                      e.target.style.borderColor = '#4A4C58';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '#171821';
                      e.target.style.borderColor = '#353748';
                    }}
                  >
                    Go to Home
                  </Button>
                </div>

                {/* Support Info */}
                <div className="mt-4">
                  <small style={{ color: '#FFFFFF' }}>
                    Having trouble? Contact our support team for assistance.
                  </small>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
} 